import styled from 'styled-components';

const EditButton = styled.a`
  text-transform: none;
  font-family: 'Avenir Light', 'Arial', sans-serif;
  font-size: 15px;
`;

export default EditButton;
